import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';

export const steps = {
  video: 'video',
  series: 'series',
  collection: 'collection',
};

export const useAppHomeStore = create((set, get) => ({
  currentStep: '',
  setCurrentStep: currentStep => set({ currentStep }),
  appList: [],
  setAppList: appList => set({ appList }),
  addAppListItem: () => {
    return set(state => ({
      appList: [...state.appList, { title: '', id: uuidv4() }],
    }));
  },
  removeAppListItem: id => {
    return set(state => ({
      appList: state.appList.filter(list => list.id !== id),
    }));
  },
  getTitleById: id => {
    const item = get().appList.find(item => item.id === id);
    return item ? item.title : null;
  },
  setTitleById: (id, newTitle) => {
    return set(state => ({
      appList: state.appList.map(item =>
        item.id === id ? { ...item, title: newTitle } : item
      ),
    }));
  },
}));
